'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _classnames5 = require('classnames');
var _classnames6 = _interopRequireDefault(_classnames5);
var _IconButton = require('@material-ui/core/IconButton');
var _IconButton2 = _interopRequireDefault(_IconButton);
var _KeyboardArrowRight = require('@material-ui/icons/KeyboardArrowRight');
var _KeyboardArrowRight2 = _interopRequireDefault(_KeyboardArrowRight);
var _KeyboardArrowLeft = require('@material-ui/icons/KeyboardArrowLeft');
var _KeyboardArrowLeft2 = _interopRequireDefault(_KeyboardArrowLeft);
var _isEqual = require('lodash/isEqual');
var _isEqual2 = _interopRequireDefault(_isEqual);
var _map = require('lodash/map');
var _map2 = _interopRequireDefault(_map);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  container: {
    marginTop: 32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    position: 'relative'
  },
  list: {
    float: 'left',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    display: 'flex'
  },
  item: {
    padding: '8px 12px',
    display: 'inline-block',
    height: 36,
    minWidth: 90
  },
  selectableList: {
    cursor: 'pointer'
  },
  iconButtonWrapper: {
    position: 'absolute',
    zIndex: 10,
    height: 56,
    width: 56
  },
  leftScrollButton: {
    left: -52
  },
  rightScrollButton: {
    right: -52
  }
};
var ScrollableItems = function (_Component) {
  _inherits(ScrollableItems, _Component);
  function ScrollableItems(props) {
    _classCallCheck(this, ScrollableItems);
    var _this = _possibleConstructorReturn(this, (ScrollableItems.__proto__ || Object.getPrototypeOf(ScrollableItems)).call(this, props));
    _this.easeInOutQuad = function (t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    };
    _this.onClickItem = function (itemValue) {
      var value = _this.state.value;
      if (value && value !== itemValue) {
        _this.setState({
          value: itemValue
        });
        _this.props.onChange(itemValue);
      }
    };
    _this.scroll = function (right) {
      var list = _this.listRef.current;
      var _this$state = _this.state,
        showLeftButton = _this$state.showLeftButton,
        showRightButton = _this$state.showRightButton;
      if (!list) return;
      var start = list.scrollLeft;
      var currentTime = 0;
      var duration = 1000;
      var increment = 20;
      var change = right ? 150 : -150;
      var animateScroll = function animateScroll() {
        currentTime += increment;
        var quantity = _this.easeInOutQuad(currentTime, start, change, duration);
        list.scrollLeft = quantity;
        if (currentTime < duration) setTimeout(animateScroll, increment);
      };
      animateScroll();
      _this.setState({
        showLeftButton: list.scrollLeft + change > 0
      });
      _this.setState({
        showRightButton: change + list.clientWidth + list.scrollLeft < list.scrollWidth
      });
    };
    _this.renderScrollButton = function () {
      var right = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props = _this.props,
        classes = _this$props.classes,
        extraClasses = _this$props.extraClasses;
      return _react2.default.createElement('div', {
        className: (0, _classnames6.default)(classes.iconButtonWrapper, extraClasses.scrollButton, _defineProperty({}, classes.rightScrollButton, right), _defineProperty({}, classes.leftScrollButton, !right)),
        onClick: function onClick() {
          return _this.scroll(right);
        },
        'aria-label': right ? "right" : "left"
      }, right ? _react2.default.createElement(_KeyboardArrowRight2.default, null) : _react2.default.createElement(_KeyboardArrowLeft2.default, null));
    };
    _this.listRef = _react2.default.createRef();
    _this.state = {
      value: props.value,
      showLeftButton: false,
      showRightButton: false
    };
    return _this;
  }
  _createClass(ScrollableItems, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var list = this.listRef.current;
      if (list && list.clientWidth + list.scrollLeft < list.scrollWidth) this.setState({
        showRightButton: true
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) this.setState({
        value: this.props.value
      });
      var objMapped = (0, _map2.default)(prevProps.items, 'itemValue');
      var otherMapped = (0, _map2.default)(this.props.items, 'itemValue');
      if (!(0, _isEqual2.default)(objMapped, otherMapped)) {
        var list = this.listRef.current;
        if (list) {
          this.setState({
            showRightButton: list.clientWidth + list.scrollLeft < list.scrollWidth
          });
        }
        this.setState({
          showLeftButton: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        classes = _props.classes,
        extraClasses = _props.extraClasses,
        getSelectedStyle = _props.getSelectedStyle,
        items = _props.items,
        value = _props.value,
        _props$visibleButtons = _props.visibleButtons,
        visibleButtons = _props$visibleButtons === undefined ? false : _props$visibleButtons;
      return _react2.default.createElement('div', {
        className: classes.container
      }, (visibleButtons || this.state.showLeftButton) && this.renderScrollButton(), _react2.default.createElement('div', {
        className: (0, _classnames6.default)(classes.list, extraClasses.list, _defineProperty({}, classes.selectableList, value)),
        ref: this.listRef
      }, items.map(function (_ref) {
        var children = _ref.children,
          itemValue = _ref.itemValue;
        return _react2.default.createElement('div', {
          key: itemValue,
          className: (0, _classnames6.default)(classes.item, _defineProperty({}, extraClasses.selectedItem, _this2.state.value === itemValue)),
          onClick: function onClick() {
            return _this2.onClickItem(itemValue);
          },
          style: getSelectedStyle && getSelectedStyle(itemValue === _this2.state.value)
        }, children);
      })), (visibleButtons || this.state.showRightButton) && this.renderScrollButton(true));
    }
  }]);
  return ScrollableItems;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(ScrollableItems);